import React from 'react'
import { Modal, ModalHeader, ModalFooter, ModalBody, Button } from 'reactstrap'
import { ModalState } from '../types/dialog-types'
import { Translate } from 'react-redux-i18n'

export interface Props {
  modal: ModalState | null
  confirm: () => void
  decline: () => void
}

export interface State {
  backdrop: boolean
}

class ModalDialog extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      backdrop: false,
    }
  }

  public render(): React.ReactNode {
    const { decline, confirm, modal } = this.props
    const { backdrop } = this.state
    if (modal) {
      return (
        <Modal isOpen={true} toggle={decline} backdrop={backdrop} autoFocus={false}>
          <ModalHeader toggle={decline}>{modal.title}</ModalHeader>
          <ModalBody>{modal.message}</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={confirm} autoFocus={true} data-cy="confirm">
              <Translate value={'confirm'} />
            </Button>{' '}
            <Button color="secondary" onClick={decline} data-cy="cancel">
              <Translate value={'cancel'} />
            </Button>
          </ModalFooter>
        </Modal>
      )
    } else {
      return <span />
    }
  }
}

export default ModalDialog
